import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer'; 
import { Link, useSearchParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import '../App.css';
import API_BASE_URL from '../apiConfig';

const CHECKOUT_API_URL = `${API_BASE_URL}/create-checkout-session`;

// REPLACE with your actual pk_test_ key
const STRIPE_PUBLISHABLE_KEY = 'pk_live_51SXTJiEKawy6PJ7cgc1JgxhKXrAFZuVn6rx5BNZY8UZewlvwAQDNoucBBT7uScDQEIwI8f6DjMHDFs20u9c4ll2d000RaHTxBK'; 
const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY); 

const CREDIT_PACKS = [
  { id: 1, credits: 10, price: 49.00, title: 'Starter Pack', description: 'Perfect for initial testing and small batches.' },
  { id: 2, credits: 50, price: 199.00, title: 'Pro Pack', description: 'Our best value for regular hiring volume.' },
  { id: 3, credits: 100, price: 299.00, title: 'Team Pack', description: 'Volume discount for growing teams and agencies.' },
];

function BillingPage() {
  const { token, user } = useAuth();
  const [loadingId, setLoadingId] = useState(null);
  const [message, setMessage] = useState('');
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('success')) {
      // UPDATED MESSAGE: Confirms immediate action
      setMessage('🎉 Payment succeeded! Your credits have been added to your balance.');
    } else if (searchParams.get('cancelled')) {
      setMessage('Payment cancelled. Your account has not been charged.');
    }
  }, [searchParams]);

  const handlePurchase = async (pack) => {
    if (!token) {
        alert("You must be logged in to purchase credits.");
        return;
    }

    setLoadingId(pack.id);
    setMessage(`Creating secure session for ${pack.credits} credits...`);

    try {
      const response = await axios.post(CHECKOUT_API_URL, { credits: pack.credits }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const session = response.data; 
      window.location.replace(session.url);

    } catch (error) {
      console.error("Stripe Session failed:", error);
      setMessage('Failed to initiate payment session. Check the console.');
    } finally {
      setLoadingId(null);
    }
  };

  const currentBalance = user?.credit_balance || 0;

  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      
      <header className="App-header" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '40px' }}>
        
        {/* --- FIX IS HERE: width: '90%' + maxWidth ensures it never touches edges --- */}
        <div className="form-container" style={{maxWidth: '1000px', width: '90%', textAlign: 'left', margin: '0 auto'}}>
          
          <Link to="/dashboard" className="back-link">{"<"} Back to Dashboard</Link>
          
          <h2 style={{alignSelf: 'center', marginBottom: '20px', textAlign: 'center'}}>Purchase Assessment Credits</h2>
          
          {message && <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: message.startsWith('🎉') ? '#e8f5e9' : '#fff3cd', borderRadius: '4px' }}>{message}</div>}

          {/* Current Balance Box */}
          {user && (
            <div className="result-card score-summary-card" style={{borderLeftColor: '#0052cc', marginBottom: '30px', width: '100%'}}>
              <h3>Current Balance: <span className="total-score" style={{color: '#0052cc'}}>{currentBalance}</span> credits</h3>
              <p>1 credit = 1 Generated Assessment</p>
            </div>
          )}

          {/* Pricing Options Container */}
          <div className="credit-pack-container">
            {CREDIT_PACKS.map((pack) => (
              <div key={pack.id} className="credit-pack-card">
                <div>
                  <h4>{pack.title}</h4>
                  <p style={{fontSize: '0.9rem', color: '#666'}}>{pack.description}</p>
                </div>
                
                <div className="pack-details">
                  <span className="pack-price">${pack.price.toFixed(2)}</span>
                  <button 
                    className="generate-button"
                    onClick={() => handlePurchase(pack)}
                    disabled={loadingId === pack.id}
                    style={{width: '100%'}} 
                  >
                    {loadingId === pack.id ? 'Loading...' : `Buy ${pack.credits} Credits`}
                  </button>
                </div>
              </div>
            ))}
          </div>

        </div>
      </header>
      <Footer /> 
    </div>
  );
}

export default BillingPage;